/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as CommandesRouteImport } from './routes/commandes'
import { Route as ContratsRouteImport } from './routes/contrats'
import { Route as InterimairesRouteImport } from './routes/interimaires'
import { Route as ConfigClientVmsConfigRouteImport } from './routes/config/client-vms-config'
import { Route as ConfigDocumentMappingRouteImport } from './routes/config/document-mapping'
import { Route as ConfigRubriquesClientsRouteImport } from './routes/config/rubriques-clients'
import { Route as PixidParamDematRouteImport } from './routes/pixid/param-demat'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CommandesRoute = CommandesRouteImport.update({
  id: '/commandes',
  path: '/commandes',
  getParentRoute: () => rootRouteImport,
} as any)
const ContratsRoute = ContratsRouteImport.update({
  id: '/contrats',
  path: '/contrats',
  getParentRoute: () => rootRouteImport,
} as any)
const InterimairesRoute = InterimairesRouteImport.update({
  id: '/interimaires',
  path: '/interimaires',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigClientVmsConfigRoute = ConfigClientVmsConfigRouteImport.update({
  id: '/config/client-vms-config',
  path: '/config/client-vms-config',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigDocumentMappingRoute = ConfigDocumentMappingRouteImport.update({
  id: '/config/document-mapping',
  path: '/config/document-mapping',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigRubriquesClientsRoute = ConfigRubriquesClientsRouteImport.update({
  id: '/config/rubriques-clients',
  path: '/config/rubriques-clients',
  getParentRoute: () => rootRouteImport,
} as any)
const PixidParamDematRoute = PixidParamDematRouteImport.update({
  id: '/pixid/param-demat',
  path: '/pixid/param-demat',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/commandes': typeof CommandesRoute
  '/contrats': typeof ContratsRoute
  '/interimaires': typeof InterimairesRoute
  '/config/client-vms-config': typeof ConfigClientVmsConfigRoute
  '/config/document-mapping': typeof ConfigDocumentMappingRoute
  '/config/rubriques-clients': typeof ConfigRubriquesClientsRoute
  '/pixid/param-demat': typeof PixidParamDematRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/commandes': typeof CommandesRoute
  '/contrats': typeof ContratsRoute
  '/interimaires': typeof InterimairesRoute
  '/config/client-vms-config': typeof ConfigClientVmsConfigRoute
  '/config/document-mapping': typeof ConfigDocumentMappingRoute
  '/config/rubriques-clients': typeof ConfigRubriquesClientsRoute
  '/pixid/param-demat': typeof PixidParamDematRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/commandes': typeof CommandesRoute
  '/contrats': typeof ContratsRoute
  '/interimaires': typeof InterimairesRoute
  '/config/client-vms-config': typeof ConfigClientVmsConfigRoute
  '/config/document-mapping': typeof ConfigDocumentMappingRoute
  '/config/rubriques-clients': typeof ConfigRubriquesClientsRoute
  '/pixid/param-demat': typeof PixidParamDematRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/commandes'
    | '/contrats'
    | '/interimaires'
    | '/config/client-vms-config'
    | '/config/document-mapping'
    | '/config/rubriques-clients'
    | '/pixid/param-demat'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/commandes'
    | '/contrats'
    | '/interimaires'
    | '/config/client-vms-config'
    | '/config/document-mapping'
    | '/config/rubriques-clients'
    | '/pixid/param-demat'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/commandes'
    | '/contrats'
    | '/interimaires'
    | '/config/client-vms-config'
    | '/config/document-mapping'
    | '/config/rubriques-clients'
    | '/pixid/param-demat'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  CommandesRoute: typeof CommandesRoute
  ContratsRoute: typeof ContratsRoute
  InterimairesRoute: typeof InterimairesRoute
  ConfigClientVmsConfigRoute: typeof ConfigClientVmsConfigRoute
  ConfigDocumentMappingRoute: typeof ConfigDocumentMappingRoute
  ConfigRubriquesClientsRoute: typeof ConfigRubriquesClientsRoute
  PixidParamDematRoute: typeof PixidParamDematRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commandes': {
      id: '/commandes'
      path: '/commandes'
      fullPath: '/commandes'
      preLoaderRoute: typeof CommandesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contrats': {
      id: '/contrats'
      path: '/contrats'
      fullPath: '/contrats'
      preLoaderRoute: typeof ContratsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interimaires': {
      id: '/interimaires'
      path: '/interimaires'
      fullPath: '/interimaires'
      preLoaderRoute: typeof InterimairesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/client-vms-config': {
      id: '/config/client-vms-config'
      path: '/config/client-vms-config'
      fullPath: '/config/client-vms-config'
      preLoaderRoute: typeof ConfigClientVmsConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/document-mapping': {
      id: '/config/document-mapping'
      path: '/config/document-mapping'
      fullPath: '/config/document-mapping'
      preLoaderRoute: typeof ConfigDocumentMappingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/rubriques-clients': {
      id: '/config/rubriques-clients'
      path: '/config/rubriques-clients'
      fullPath: '/config/rubriques-clients'
      preLoaderRoute: typeof ConfigRubriquesClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pixid/param-demat': {
      id: '/pixid/param-demat'
      path: '/pixid/param-demat'
      fullPath: '/pixid/param-demat'
      preLoaderRoute: typeof PixidParamDematRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  CommandesRoute: CommandesRoute,
  ContratsRoute: ContratsRoute,
  InterimairesRoute: InterimairesRoute,
  ConfigClientVmsConfigRoute: ConfigClientVmsConfigRoute,
  ConfigDocumentMappingRoute: ConfigDocumentMappingRoute,
  ConfigRubriquesClientsRoute: ConfigRubriquesClientsRoute,
  PixidParamDematRoute: PixidParamDematRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
